import React, {useEffect, useState} from 'react'


import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store/reducers";

import CadTabela from "../../components/CadTabela";


import {getAluno, getAlunos} from "../../store/actions/alunosActions";
import AlunoDialog from "../AlunoDialog";
import {Grid} from "@mui/material";
import {iAluno} from "../../types/iAluno";



const sxStyles=
{
    mainPaper: {
        minHeight: '400px'
    }
,
    
    dialogGrid: {
        marginBottom: '40px'
    }
}
interface iAlunosView {

}

const AlunosView = (props : iAlunosView) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [recId, setRecId] = useState<number | null>(null);
    const data = useSelector( (state : RootState) => state.cadastros.alunosBase );
    const aluno = useSelector( (state : RootState) => state.cadastros.aluno );
  
    const [ registro, setRegistro] = useState<object>();
    const dispatch = useDispatch();
    
    
    useEffect( () => {
        if ( (typeof aluno !== "undefined") && (typeof aluno === "object") && (aluno !== null) && (aluno.id > 0) ) {
            setRecId(aluno.id);
            setRegistro(aluno)
            
        }
    }, [ aluno ]);
    
    
    const dialogState = (param:boolean, recId?: number | null) => {
        const rId = recId?? null;
      
        if (rId !== null) {
            dispatch(getAluno(rId));
            setRecId(rId);
            setRegistro({});
        } else {
            setRecId(rId);
            setRegistro({});
        }
        setIsDialogOpen(param);
    }

    const getCadastro = () => {
        dispatch(getAlunos());
    }
    

    const columns = [
        {
            name: "id",
            label: "id",
            options: {
                display: false,
                filter: true,
                sort: true,
            }
        },
        {
            name: "Name",
            label: "NOME",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex : any) => {
                    if (
                        typeof(data[dataIndex].NomeSocial) !== "undefined" &&
                        data[dataIndex].NomeSocial !== "" &&
                        data[dataIndex].Name !== data[dataIndex].NomeSocial ) {
                                return data[dataIndex].Name + " (" + data[dataIndex].NomeSocial + ")";
                            } else {
                                return data[dataIndex].Name;
                    }
                }
                
            }
        },
        // {
        //     name: "PaymentCard",
        //     label: "CARNE ATUAL",
        //     options: {
        //         filter: true,
        //         sort: true,
        //         customBodyRenderLite: (dataIndex : any) => {
        //             return getLastPaymentCardFromStudent(data[dataIndex]);
        //         }
        //     }
        // },
        {
            name: "carnes",
            label: "CARNÊ(S)",
            options: {
                filter: true,
                sort: true,
               
            }
        },
        {
            name: "Mother",
            label: "MAE",
            options: {
                filter: true,
                sort: true,
               
            }
        },
        {
            name: "Phone",
            label: "TELEFONE",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "email",
            label: "EMAIL",
            options: {
                filter: true,
                sort: true,
            }
        }
        
    ];


    return (
        <React.Fragment>
            <Grid container  >
                
                {isDialogOpen &&
                    <Grid item container sx={{...sxStyles.dialogGrid}}  xs={12} md={12} lg={12} xl={12}>
                        <AlunoDialog isOpen={isDialogOpen} dialogState={dialogState} recId={recId} registro={registro}/>
                    </Grid>
                }
                {!isDialogOpen &&
                    <CadTabela
                        isOpen={!isDialogOpen}
                        dialogState={dialogState}
                        title="ALUNOS"
                        data={data}
                        columns={columns}
                        getCadastro={getCadastro} />
                }
            </Grid>
        </React.Fragment>
    )
}


export default (AlunosView);

